var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Filtro',{on:{"filtro":_vm.makeFiltro}}),_c('List',{ref:"list",attrs:{"filtro":_vm.filtro,"subjectPermission":_vm.subjectPermission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }